import axios from "axios";

import * as Config from "../../../Utils/config";

export async function LoginApi(data) {
  try {
    const response = await axios.post(`${Config.base_url}user/login`, data);

    return response.data;
  } catch (error) {
    console.log("Error fetching login:", error.message || error);
    throw error;
  }
}

export async function UserLoginApi(data) {
  try {
    const response = await axios.post(
      `${Config.base_url}api/client/login`,
      data
    );

    return response.data;
  } catch (error) {
    console.log("Error fetching login:", error.message || error);
    throw error;
  }
}

export async function UserSignupApi(data) {
  try {
    const response = await axios.post(`${Config.base_url}api/client/add`, data);

    return response.data;
  } catch (error) {
    console.log("Error fetching login:", error.message || error);
    throw error;
  }
}



export async function UserOtpSubmit(data) {
  try {
    const response = await axios.post(`${Config.base_url}api/client/otp_submit`, data);

    return response.data;
  } catch (error) {
    console.log("Error fetching login:", error.message || error);
    throw error;
  }
}


export async function LoginWithOtp(data, token) {

  try {
    const res = await axios.post(`${Config.base_url}user/login-with-otp`, data, {
      headers: {
        'Authorization': `${token}`
      },
    });
    return res?.data;
  } catch (err) {
    return { error: err.response?.data || err.message };
  }
}


export async function verifyloginotp(data, token) {

  try {
    const res = await axios.post(`${Config.base_url}user/verify-login-otp`, data, {
      headers: {
        'Authorization': `${token}`
      },
    });
    return res?.data;
  } catch (err) {
    return { error: err.response?.data || err.message };
  }
}


export async function LogOutAllDevice(data, token) {

  try {
    const res = await axios.post(`${Config.base_url}logoutalldevice`, data, {
      headers: {
        'Authorization': `${token}`
      },
    });
    return res?.data;
  } catch (err) {
    return { error: err.response?.data || err.message };
  }
}

